import { Text, TextProps } from "@hightouch/htui";
import { ReactNode } from "react";

export const ErrorMessage = ({
  children,
  ...props
}: { children: ReactNode } & TextProps) => {
  // TODO: migrate query builder to use form fields
  // for accessibility.
  return (
    <Text color="text.danger" mt={2} size="sm" {...props}>
      {children}
    </Text>
  );
};
